import api from "apis/customer";
import { WebApiRequest, HTTP_GET, HTTP_PUT, HTTP_POST } from "tools/webservice";


//See typeConstants/customerTypes
export const getCustomersByType = (type, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: api.getCustomersByType(type),
  successCallback,
  mountedRef
});

export const updateCustomer = (customerNumber, payload, successCallback, mountedRef) => {
  return WebApiRequest(
      {
        method: HTTP_PUT,
        endpoint: api.updateCustomerDetails(customerNumber),
        payload,
        successCallback,
        mountedRef
      });
};

export const getNextAvailableCustomerNumber = (successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: api.getNextAvailableAccountNumber(),
  successCallback,
  mountedRef
});

export const getSurveyTypesByCustomer = (customerNumber, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: api.getAllSurveyTypes(customerNumber),
  successCallback,
  mountedRef
});

export const getCustomerList = (successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: api.getCustomerList(),
  successCallback,
  mountedRef,
});

export const getMajorCompanyList = (successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: api.majorCompanies(),
  successCallback,
  mountedRef,
});

//Note that this endpoint doesn't return close outs, even if the close out survey type is active for the customer
export const getActiveSurveyTypesByCustomer = (accountNumber, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: api.getActiveSurveyTypes(accountNumber),
  successCallback,
  mountedRef,
});

export const getCustomerSurveyTypes = (successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: api.getCustomerSurveyTypes(),
  successCallback,
  mountedRef,
});

export const uploadBatchOrder = (data, successCallback, errorCallback, mountedRef) => WebApiRequest({
  method: HTTP_POST,
  endpoint: api.bulkOrder(),
  payload: null,
  file: data,
  successCallback,
  errorCallback,
  mountedRef,
  options: {
    "Content-Type": null
  }
});

export const getOrderSupplementOptions = (accountNumber, surveyTypeId, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: api.getOrderSupplementOptions(accountNumber, surveyTypeId),
  successCallback,
  mountedRef,
});

export const getEnabledFeatures = (accountNumber, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: api.getEnabledFeatures(accountNumber),
  successCallback,
  mountedRef
});

export const addCustomer = (accountNumber, payload, successCallback, errorCallback, mountedRef) => WebApiRequest({
  method: HTTP_POST,
  endpoint: api.addCustomer(accountNumber),
  payload, 
  successCallback,
  errorCallback,
  mountedRef
});

export const getSalesDetails = (accountNumber, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: api.salesDetails(accountNumber),
  successCallback,
  mountedRef
});

export const updateSalesDetails = (accountNumber, payload, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_PUT,
  endpoint: api.salesDetails(accountNumber),
  payload, 
  successCallback,
  mountedRef
});

export const getPdfExportSettings = (accountNumber, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: api.pdfExportSettingsByCustomer(accountNumber),
  successCallback,
  mountedRef
});

export const setPdfExportSettings = (accountNumber, payload, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_POST,
  endpoint: api.pdfExportSettingsByCustomer(accountNumber),
  payload, 
  successCallback,
  mountedRef
});

export const getPdfExportSettingsFields = (successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: api.pdfExportSettingsFields(),
  successCallback,
  mountedRef
});